import { Component, EventEmitter, Output } from '@angular/core';
import { OperatorListService } from '../operator-list/operator-list.service';

@Component({
  selector: 'app-table-operator-list',
  templateUrl: './table-operator-list.component.html',
  styleUrls: ['./table-operator-list.component.scss'],
})
export class TableOperatorListComponent {
  public cnpj = '';

  public rows: any[] = [];
  public productMap: { [id: string]: string } = {};

  @Output() transactionsLoaded = new EventEmitter<any[]>();

  constructor(private operatorListService: OperatorListService) {}

  productLabel(productId: any): string {
    const id = (productId ?? '').toString().trim();
    if (!id) return '-';
    return this.productMap[id] || id;
  }

  getTransactions(): void {
    this.operatorListService.getProductRegistration(1000, 1).subscribe({
      next: (productsResp: any) => {
        const products =
          productsResp?.items ??
          productsResp?.data ??
          productsResp?.result ??
          (Array.isArray(productsResp) ? productsResp : []);

        this.productMap = {};

        for (const item of products) {
          const id = (item?.id ?? item?.productId ?? '').toString().trim();
          const name = (
            item?.name ??
            item?.productName ??
            item?.description ??
            item?.title ??
            ''
          )
            .toString()
            .trim();

          if (id && name) {
            this.productMap[id] = name;
          }
        }

        this.loadPreAccounts();
      },
      error: () => {
        this.productMap = {};
        this.loadPreAccounts();
      },
    });
  }

  loadPreAccounts(): void {
    const cleanCnpj = (this.cnpj || '').replace(/\D/g, '');

    this.operatorListService.getPreAccounts(cleanCnpj).subscribe({
      next: (resp: any) => {
        const list = Array.isArray(resp)
          ? resp
          : resp?.items ??
            resp?.data ??
            resp?.result ??
            resp?.preAccounts ??
            (resp ? [resp] : []);

        this.rows = [...list].sort((a: any, b: any) => {
          const da = new Date(a?.insertDate ?? 0).getTime();
          const db = new Date(b?.insertDate ?? 0).getTime();
          return db - da;
        });

        this.transactionsLoaded.emit(this.rows);
      },
      error: () => {
        this.rows = [];
        this.transactionsLoaded.emit(this.rows);
      },
    });
  }
}
